export default __webpack_public_path__ + "static/image4-7a076e7aa301d981ccf8dd601a7b9e50.jpeg";